import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=d0b8ecea&"
import script from "./modal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./modal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports